// src/Common/ImageModal.tsx
import { useEffect } from "react";
import { createPortal } from "react-dom";
import { IoClose } from "react-icons/io5";

type ImageModalProps = {
  isOpen: boolean;
  src?: string;
  title?: string;
  onClose: () => void;
};

export default function NeflixImageModal({ isOpen, src, title, onClose }: ImageModalProps) {
useEffect(() => {
  if (!isOpen) return;

  // ✅ 포커스로 인한 스크롤 보정 방지
  (document.activeElement as HTMLElement | null)?.blur?.();

  const onKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") onClose();
  };
  document.addEventListener("keydown", onKey);

  const prev = document.body.style.overflow;
  document.body.style.overflow = "hidden";

  return () => {
    document.removeEventListener("keydown", onKey);
    document.body.style.overflow = prev;
  };
}, [isOpen, onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className="fixed inset-0 z-[999] flex items-center justify-center bg-black/80"
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      {/* 카드 컨테이너 */}
      <div
        className="relative w-[92vw] max-w-screen-sm md:w-[520px] bg-transparent"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative rounded-2xl overflow-hidden shadow-2xl border-[1px] border-gray-900">
          {src && (
            <img
              src={src}
              alt={title ?? "Preview"}
              className="w-full h-auto object-contain bg-black"
            />
          )}

          <button
            aria-label="Close"
            onClick={onClose}
            className="absolute top-2 right-2 inline-flex items-center justify-center rounded-full bg-black/60 hover:bg-black/80 transition p-2 backdrop-blur-sm"
          >
            <IoClose className="w-6 h-6 text-white" />
          </button>

          {title && (
            <div className="pointer-events-none absolute inset-x-0 bottom-0">
              {/* 그라데이션 배경 */}
              <div className="h-24" />
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}